// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__olHIb","input":"styles_input__3ugqd"};